import React from 'react'

export const customerid = React.createContext()